import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminAction } from 'src/app/models/adminaction.model';
import { SchoolModuleBatch, SchoolModuleEvent } from 'src/app/models/module/moduledetails';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { ChartOptions, ChartType } from 'chart.js';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';
import { delay } from 'rxjs';

declare const $: any;

@Component({
  selector: 'app-modulestudentlist',
  templateUrl: './modulestudentlist.component.html',
  styleUrls: ['./modulestudentlist.component.css'],
})
export class ModulestudentlistComponent implements OnInit {
    
  p: number = 1;
  students: any;
  stats: any;
  itemsPerPage = 25;
  totalItems: any;
  data: any;
  moduleid: number;
  allowBatches: false;
  moduleBatches: SchoolModuleBatch[] = [];
  batchFilterActions: AdminAction[] = [];
  count: number;
  //filteredStudents: any[];
  //activeFilterId: number = 0;
  filterOptions: any;
  removeColumn = ["count", "passed", "completedLessons", "studentId"];
  selectedBatchId: number = 0;
  schdata: any;
  adminActions: AdminAction[] = [];
  noStudentText = "No students enrolled";
  moduleStats: any;
  doughnutChartLabels = [];
  doughnutChartLabels2 = [];
  doughnutChartDatasets;
  doughnutChartDatasets2;
  doughnutChartType: ChartType = 'doughnut';
  lessonStat: any;
  isLessonStatLoading: boolean;
  @ViewChild('actionslink') actionsLink: ElementRef;
  filterValues = [['All Lessons Passed','passed', '#98fb98'], ['Yet to pass', 'nopass', '#FFA756'], ['Course marked as completed', 'completed', '#5edeefff'], 
              ['Some lessons completed' ,'somelessonscompleted', '#6583c9ff'], ['All lessons incomplete', 'nostart', '#ec4848ff']];

  constructor(
    public modulemanager: ModulemanagementService,
    public toastr: ToastrService,
    public headerinfo: ComponentheaderService,
    public router: ActivatedRoute,
    public route: Router,
    public classservice: ClassmanagementService
    ) 
  {
      headerinfo.setHeaderDisplay(`Course Students List`, [], []);
      this.moduleid = this.router.snapshot.queryParams.moduleid; 
      this.modulemanager.getModuleStudentsStat(this.moduleid).subscribe(
        (res) => {
          this.moduleStats = res;
          let allLessonsIncomplete = this.moduleStats.activeStudentsCount - this.moduleStats.numberOfStudentsWithAtLeastOneCompleteLesson;
          let someLessonsCompleted = this.moduleStats.numberOfStudentsWithAtLeastOneCompleteLesson - this.moduleStats.totalStudentsCompleted;
          let passed = this.moduleStats.totalStudentsPassed;
          let notPassed = this.moduleStats.totalStudentNotPassed;
          this.doughnutChartDatasets = [{ 
            data: [ someLessonsCompleted, this.moduleStats.totalStudentsCompleted, allLessonsIncomplete ],
            backgroundColor: ['#6583c9ff', '#5edeefff', '#ec4848ff']
          }];
          this.doughnutChartLabels = [ `Some lessons completed: ${someLessonsCompleted}`, 
            `Course marked as completed: ${this.moduleStats.totalStudentsCompleted}`, `All lessons incomplete: ${allLessonsIncomplete}`];
          
          this.doughnutChartDatasets2 = [{ 
            data: [ notPassed, passed, allLessonsIncomplete ],
            backgroundColor: ['#FFA756', '#98fb98', '#ec4848ff']
          }];
          this.doughnutChartLabels2 = [ `Yet to pass: ${notPassed}`, `All lessons passed: ${passed}`, `All lessons incomplete: ${allLessonsIncomplete}`];
        }
      );
  }
    
  async ngOnInit() {
    this.headerinfo.pageLoadingStarted(this);
    this.adminActions.push({displaytext: 'Export', callback: this.export.bind(this), classes: ['fas', 'fa-cloud-download-alt']});   
    this.headerinfo.setHeaderDisplay(
      `Course Students`,
      [
        {
          displaytext: 'School',
          route: `/user/schoolhome`,
          //params: { moduleID: this.moduleid },
        },
        {
          displaytext: 'Course',
          route: `/user/moduledetails`,
          params: { moduleID: this.moduleid },
        },
        {
          displaytext: `Registered Students`,
          route: `/user/modulestudentlist`,
          params: this.router.snapshot.queryParams,
        },
      ],
      this.adminActions
    );
    this.headerinfo.pageLoadingDone(this);
  }

  export() {
    // this.modulemanager.downloadModuleStudentList(this.moduleid).subscribe();
    this.headerinfo.pageLoadingStarted(this);
    try {

    this.modulemanager
    .downloadModuleStudent(this.moduleid)
    .subscribe((response: any) => {
      const url = window.URL.createObjectURL(response);
      window.open(url);

    }),
    (error: any) => console.log('Error downloading the file'),
    () => console.info('File downloaded successfully');
    } catch (error) {

    }finally{
      this.headerinfo.pageLoadingDone(this);
    }
  }

  async loadTableData(eventData){
    try{
      this.headerinfo.pageLoadingStarted(this);
      this.schdata = await this.modulemanager.getModuleDetails(this.moduleid).toPromise();

      this.allowBatches = this.schdata?.allowBatches;
      if (this.allowBatches){
        this.moduleBatches = await this.modulemanager.getModuleBatches(this.moduleid).toPromise();
  
        let defaultBatchAction = new AdminAction();
        defaultBatchAction.displaytext = "All Batches";
        defaultBatchAction.params = {id: 0}
        this.batchFilterActions.push(defaultBatchAction);
        this.moduleBatches.forEach(b => {
          let obj = new AdminAction();
          obj.displaytext = b.name;
          obj.params = {id: b.id};
          if (!this.batchFilterActions.find(a => a.displaytext == b.name))
            this.batchFilterActions.push(obj);
        });
      };

      this.data = await this.modulemanager
        .getModuleStudents(this.moduleid, eventData.page, eventData.offset, this.setFilterData(eventData))
        .toPromise()
        .catch((err) => {
          this.toastr.error(err);
          this.route.navigate(['/user/moduledetails'], {
            queryParams: { moduleID: this.moduleid },
          });
          return;
        })
        .finally(() => this.headerinfo.pageLoadingDone(this));      
      this.setResult(eventData);               
    }
    catch(e){
      console.log(e)
    }
    finally{
      this.headerinfo.pageLoadingDone(this);
    }
  }
  setResult(eventData) {
    this.students = this.data;
    this.students.length > 0 ? this.count = this.students[0].count : 0;    
    eventData.filters?.length > 0 ? this.filterOptions = eventData.filters : this.loadFilterOptions();
  }
  setFilterData(eventData) {
    let filterParams = [];

    if (eventData?.filters) {
      for (let f of eventData.filters) {
        //get dropdown values
        if (f["value"] && (f["dropdown"] == true || f["search"] == true))
          filterParams.push({ value: f["value"], param: f["param"] });
        //get datetime values
        else if (f["value"] && f["date"] == true)
          filterParams.push({ value: new Date(f["value"]).toISOString(), param: f["param"] });        
      }
    }

    return filterParams;
  }
  loadFilterOptions() {
    this.filterOptions = new Array();
    this.filterOptions.push(
      {
        param: 'Search',
        search: true,      
        label: 'Search',
      }
    )
    this.filterOptions.push(
      {
        param: 'Filter',
        dropdown: true,
        date: false,
        label: "Filter By",
        dropdownOptions: this.filterValues.map(item => {
          return {
            displaytext: item[0].toUpperCase(),
            value: item[1],
            bgcolor: item[2]
          }
        })
      },
    )
    if(this.schdata?.allowBatches){
      this.filterOptions.push(       
        { param: 'Batch', dropdown: true, date: false,
          label: "Batch", dropdownOptions: this.batchFilterActions.map(item => {
            return { displaytext: item.displaytext, value: item.params.id }})
        },
      );
    }    
  }
  async rowClicked(event){
    try{
      $('#lessonstatmodal').modal('show');    
      this.isLessonStatLoading = true;
      this.lessonStat = await this.modulemanager.getStudentModuleStats(this.moduleid, event['studentId']).toPromise();
    }
    finally{
      this.isLessonStatLoading = false;
    }    
  }

  hasAnyLessonStarted(lessons: any){    
    return lessons?.some(l => l.completed);
  }
}
